import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { KenhSanModel } from '../kenh-san-model/kenh-san.model';
const API_ROOT_URL = environment.ApiRoot + '/danhmuc/kenhsan';
@Injectable()
export class KenhSanService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }
	list(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + "/list", { 
			headers: httpHeaders,
			params: httpParams
		});
	}

	listDropdown(): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + "/list", { 
			headers: httpHeaders
		});
	}
	
	getKenhSanById(itemId: any): Observable<any> {
		return this.http.get<any>(API_ROOT_URL + `?id=${itemId}`);
	}

	delete(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}?id=${itemId}`;
		return this.http.delete<any>(url, { headers: httpHeaders });
	}

	insert(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<KenhSanModel>(API_ROOT_URL, item, { headers: httpHeaders });
	}

	update(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.put<KenhSanModel>(API_ROOT_URL, item, { headers: httpHeaders });
	}
	
}
